// src/routes/_authenticated/settings/lawyer-profile.tsx
import LawyerProfilePage from '@/views/lawyer-profile'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/lawyer-profile')({
  component: LawyerProfilePage,
})
